import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { ActionIcon, TextInput, useComputedColorScheme } from '@mantine/core';
import React, { useEffect, useState } from 'react';

import styles from './book-search.module.scss';

interface BookSearchProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}

export const BookSearch: React.FC<BookSearchProps> = ({
  value = '',
  onChange,
  placeholder = 'Поиск',
}) => {
  const [query, setQuery] = useState(value);
  const computedColorScheme = useComputedColorScheme('light', {
    getInitialValueInEffect: true,
  });

  // Debounce search input
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (onChange && query !== value) {
        onChange(query);
      }
    }, 500); // 500ms debounce

    return () => clearTimeout(timeoutId);
  }, [query, onChange, value]);

  // Update local state when external value changes
  useEffect(() => {
    setQuery(value);
  }, [value]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const inputClass = `${
    computedColorScheme === 'dark'
      ? styles.search__input_dark
      : styles.search__input_light
  }`;

  return (
    <TextInput
      placeholder={placeholder}
      value={query}
      onChange={handleSearchChange}
      radius="md"
      leftSection={
        <ActionIcon variant="white" color="#B4B4B4">
          <MagnifyingGlassIcon width={20} height={20} />
        </ActionIcon>
      }
      className={styles.search}
      my={28}
      classNames={{
        input: inputClass,
      }}
    />
  );
};
